<template>
    <div class="content-wrapper">
        <!-- Page Loader -->
        <div class="vld-parent">
            <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
        </div>

        <breadcrumb :page="$t('form.student.studentImportList')"></breadcrumb>

        <div class="content">
           <div class="container-fluid">

                <b-alert v-model="alert" :variant="alertClass" dismissible fade>{{alertMessage}}</b-alert>

                <!-- Filters -->
                <div class="card">
                    <div class="card-header bg-light">
                        <h3 class="card-title">{{$t('form.student.studentImportList')}}</h3>


                         <button v-show="studentList.length" type="submit" class="btn btn-primary float-right"
                            @click="acceptStudentFile">{{$t('form.student.import')}} {{studentList.length}} {{$t('form.student.record')}} <span v-show="studentList.length > 1">(s)</span> </button>
                        <button type="submit" class="btn btn-danger float-right mr-3"
                            @click="rejectStudentFile">{{$t('button.cancel')}}</button>
                    </div>

                    <div class="card-body">
                        <!-- table  -->
                        <div class="card-body table-responsive p-0">
                            <table class="table table-hover">
                                <thead>
                                    <tr class="header">
                                        <th>{{$t('form.student.partnerCode')}}</th>
                                        <th>{{$t('form.student.PartnerCampusLocation')}}</th>
                                        <th>{{$t('form.student.title')}}</th>
                                        <th>{{$t('form.student.firstName')}}</th>
                                        <th>{{$t('form.student.lastName')}}</th>
                                        <th>{{$t('form.student.country')}}</th>
                                        <th>{{$t('form.student.notes')}}</th>
                                        <th>{{$t('form.student.birthDate')}}</th>
                                        <th>{{$t('form.student.birthPlace')}}</th>
                                        <th>{{$t('form.student.birthCountry')}}</th>
                                        <th>{{$t('form.student.email')}}</th>
                                        <th>{{$t('form.student.email2')}}</th>
                                        <th>{{$t('form.student.email3')}}</th>
                                        <th>{{$t('form.student.phone')}}</th>
                                        <th>{{$t('form.student.mobile')}}</th>
                                        <th>{{$t('form.student.programCode')}}</th>
                                        <th> {{$t('form.student.program')}} {{$t('form.student.title')}}</th>
                                        <th>{{$t('form.student.programType')}}</th>
                                        <th>{{$t('form.student.academicYear')}}</th>
                                        <th>{{$t('form.student.programCode2')}}</th>
                                        <th>{{$t('form.student.programTitle2')}}</th>
                                        <th>{{$t('form.student.programType2')}}</th>
                                        <th>{{$t('form.student.academicYear2')}}</th>
                                        <th>{{$t('form.student.studentNumber')}}</th>
                                        <th>{{$t('form.student.sisEnabled')}}</th>
                                        <th>{{$t('form.student.gradeNotifications')}}</th>
                                        <th>{{$t('form.student.programStart')}}</th>
                                    </tr>
                                </thead>
                                <tbody>

                                    <tr v-for="(student, index) in studentList" v-bind:key="index">
                                        <td  v-for="(td, tdindex) in student" v-bind:key="'td'+tdindex">
                                            {{td}}

                                        </td>
                                    </tr>


                                     <tr v-show="duplicateList.length"  v-for="(student, index) in duplicateList" v-bind:key="studentList.length+index">
                                        <td  v-for="(td, tdindex) in student" v-bind:key="'td'+tdindex">

                                            <span style="color:red">
                                                {{td}}
                                            </span>

                                        </td>
                                    </tr>

                                </tbody>
                            </table>



                            <!-- <p class="p-3 m-0" v-else>{{$t('noRecord')}}</p> -->
                        </div>
                        <!-- table end  -->


                    </div>
                </div>

           </div>
        </div>

    </div>
</template>

<script>
    import vue2Dropzone from "vue2-dropzone";

    export default {
        props: ["permissions", "dateFormat", "user"],
        components: {
            vueDropzone: vue2Dropzone
        },

        data() {
            return {

                studentList:[],
                duplicateList:[],
                importFileHeader:[],
                isAccepted:false,
                filePath:'',
                alert: false,
                alertClass: "",
                alertMessage: "",

                isLoading: false,
                fullPage: true,

                header: true,
                delimiter: false,
                qualifier: false,
                statusID: null,
                statusComment: '',
                statusList: []
            };
        },

        mounted() {

            if (!this.permissions.createImportStudents) {
                this.$router.push("/");
                return;
            }

            this.setLocalVariableData();
        },

        computed: {
            isSBSUser() {
                return this.user.partner_id == 1;
            },
        },

        methods: {
            async setLocalVariableData(){
                let list = localStorage.getItem('students');
                if(list)
                this.studentList =  JSON.parse(list);

                this.duplicateList = JSON.parse(localStorage.getItem('duplicates'));
                this.filePath = localStorage.getItem('path');

                if(this.studentList.length)
                {
                    let msg = '';
                    if( this.studentList.length > 1)
                     msg =  this.studentList.length + ' records imported successfully.';
                    else
                     msg =  this.studentList.length + ' record imported successfully.';
                    window.localStorage.setItem('dataSaved',msg);
                }

            },

            rejectStudentFile() {

                this.isLoading = true;
                axios.post('/api/students/cancel-import' , {path: this.filePath}).
                then(resp=>{
                    this.isLoading = false;
                    this.$router.push('/student-import');
                })
                .catch(error=>{
                    this.isLoading = false;
                    this.$router.push('/student-import');
                })

            },

            acceptStudentFile(){


                let formData = new FormData();
                let vm = this;
                formData.append("students", JSON.stringify(this.studentList));
                formData.append("path",this.filePath);
                if (localStorage.getItem("status_id") != null) {

                     formData.append("status_id", localStorage.getItem("status_id"));
                     formData.append("status_comment", localStorage.getItem("status_comment"));

                    }
                this.isLoading = true;
                axios
                    .post("/api/students/save" , formData)
                    .then(response => {
                        this.isLoading = false;
                         vm.$router.push('/student-import');
                    })
                    .catch(error =>{
                        this.showAlert(error.response.data.message, "danger");
                        this.isLoading = false;
                    });

                    this.studentList = [];
                    this.duplicateList = [];
                    localStorage.setItem('studetns' ,JSON.stringify([]))
                    localStorage.setItem('dublicates' ,JSON.stringify([]))
                    window.localStorage.removeItem('status_id');
                    window.localStorage.removeItem('status_comment');
            },

            showAlert(msg, cls = "success") {
                this.alertMessage = msg;
                this.alertClass = cls;
                this.alert = true;
            }
        }
    };

</script>
